import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoProveedoresPage: React.FC = () => (
  <CatalogoPageLayout
    title="Proveedores"
    description="Centralizá datos de proveedores, contactos, condiciones y timbrados vigentes."
    helperText="Aquí se enlazará la información que usan compras y cuentas por pagar."
  />
);

export default CatalogoProveedoresPage;
